import { gql, type OperationVariables } from '@apollo/client';
import type { EShareBy } from '@sharedInterfaces/globalEnums';

import GraphQL from '../graphQL';

const query = gql`
  mutation shareViaServer($shareBy:String!, $employees: [Int!]!, $text: String!) {
    shareViaServer(shareBy:$shareBy, employees: $employees, text: $text)
  }
`;

export default async function shareViaServer(shareBy: EShareBy, employees: number[], text: string) {
    const variables: OperationVariables = {
        shareBy,
        employees,
        text,
    };
    return GraphQL.mutate<unknown>(query, variables);
}
